//mis-app/src/pages/ComplaintsEdit.js
import { useLocation, useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import { Divider, useTheme } from "@mui/material";
import { tokens } from "../../theme";

import {TextField, Typography, Slider }from '@mui/material';
import Stack from '@mui/material/Stack';
import { CloseRounded, Description } from "@mui/icons-material";
import Modal from '@mui/material/Modal';
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

import env from "react-dotenv";
import { format } from 'date-fns';

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box className="outer"
      sx={{
        // bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#f2f0f0'),
        // color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
        // border: '3px solid',
        //  borderColor: (theme) =>
        //   theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
        // p: 1,
        //  borderRadius: 2,
        fontSize: '0.875rem',
        fontWeight: '500',
        ...sx,
      }}
      {...other}
    />
  );
}
Item.propTypes = {
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

const Edit = ({ open, onClose, rowData }) => {
  const navigate = useNavigate();
  
  const [editData, setEditData] = useState({
    id:"",
    warranty_rejection_advice_no: "",  
    warranty_rejection_advice_date: "",
    recovery_effective_date: "",
    warranty_complaint_from: "",
    rly: "",
    item:"",
    qty_rejected_under_warranty:"",
    inspection_by: "",
    manufacturing_date: "",
    life_of_item:"",
    original_claim_value:"",
    reason_of_rejection: "",
  });

  const location = useLocation();
  useEffect( () => {
   
    if(location.key === undefined || location.key === null || location.key === 'default'){
    
      navigate("/");   
    }
  }, [ location ] );

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [monthyear, setMonthYear] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const submitLockRef = useRef(false);

  const getDataFromDb = async () => {
   
    try {
      if (rowData) {
          const { id, field, dataId } = rowData;
         
          try { 
              const res = await fetch(
              `${process.env.REACT_APP_MISBACKEND_URL}/complaints/${dataId}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
            const response = await res.json();
            // setEditData(response[0]);
            // setMonthYear(moment(new Date(response[0].manufacturing_date)).format("MMM-yy")); 
            
            // Format the dates before setting the state
            const formattedData = {
              ...response[0],
              warranty_rejection_advice_date: response[0].warranty_rejection_advice_date && format(new Date(response[0].warranty_rejection_advice_date), 'yyyy-MM-dd'),
              recovery_effective_date: response[0].recovery_effective_date && format(new Date(response[0].recovery_effective_date), 'yyyy-MM-dd'),
              manufacturing_date: response[0].manufacturing_date && format(new Date(response[0].manufacturing_date), 'yyyy-MM-dd'), // Change format as needed
            };

            setEditData(formattedData);
            
          } catch (error) {
            console.log(error);
          }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDataFromDb(editData);  
  }, [rowData]);

  // Handle changes to form fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  // function convertDate(str) {
  //   // Add a year prefix (assuming current year, e.g. 2022 for "Jul-22")
  //   const date = new Date(str + "-01"); // Adding a day ("-01") to make it a valid date
  //   const year = date.getFullYear();
  //   const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-indexed
  //   const day = "01"; // Default to 1st of the month
  
  //   return `${year}-${month}-${day}`;
  // }

  //Calculate life of item based on months
  const calculateLifeOfItem = (manufacturingDate, warrantyAdviceDate) => {
    if (!manufacturingDate || !warrantyAdviceDate) return 0;

    const manufacturing = new Date(manufacturingDate);
    const warrantyAdvice = new Date(warrantyAdviceDate);

    // Calculate the difference in months
    const yearDiff = warrantyAdvice.getFullYear() - manufacturing.getFullYear();
    const monthDiff = warrantyAdvice.getMonth() - manufacturing.getMonth();

    // Total difference in months
    const totalMonths = yearDiff * 12 + monthDiff;

    return totalMonths;
};

  // Save the changes and send to backend
  const handleSave = async () => {
    if (isSaving || submitLockRef.current) {
      return;
    }
    
    try {
      submitLockRef.current = true;
      setIsSaving(true);
      if( editData['warranty_rejection_advice_date'] !== null){
        const adviceDate = editData['warranty_rejection_advice_date'].split('T')[0];
        editData['warranty_rejection_advice_date'] = adviceDate;
      }
      if (editData['recovery_effective_date']) {
        editData['recovery_effective_date'] = String(editData['recovery_effective_date']).split('T')[0];
      }
       
      // Format the manufacturing date
      if (editData['manufacturing_date'] instanceof Date) {
        editData['manufacturing_date'] = moment(editData['manufacturing_date']).format("YYYY-MM-DD");
      }

      // Calculate life_of_item in months
      const lifeOfItem = calculateLifeOfItem(editData['manufacturing_date'], editData['warranty_rejection_advice_date']);
      editData['life_of_item'] = lifeOfItem;
      
      const response = await fetch(`${process.env.REACT_APP_MISBACKEND_URL}/updateComplaints`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editData),
      });
      const res = await response.json();
      
      onClose(); // Close the modal
      navigate('../efficiencyHome/5');
      window.location.reload(); // Refresh the page     
      // navigate(0);
      
    } catch (error) {
     
      console.error('Error saving data:', error);
    } finally {
      submitLockRef.current = false;
      setIsSaving(false);
    }
  };

  const modalStyle1 = {
    maxWidth: 500,marginLeft:"330px", marginTop:"30px",
  
    };

    function Bar() {
      return (
        <Box
          sx={{
            height: 10,
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? 'rgba(0, 0, 0, 0)'
                : 'rgb(0, 0, 0, 0)',
          }}
        />
      );
    } 
  return (open) ? (
    <Modal style={modalStyle1} className="outer1" open={open} onClose={onClose}>
    <div style={{ width: "100%", 
          borderColor: colors.blueAccent[300],border: '1px solid',
              p: 1,backgroundColor: colors.primary[400],
              borderRadius: 1}}  >
    <button className="addButton" onClick={() => onClose()}><CloseRounded/></button>
 
    <form style={{ marginLeft:"5px",marginRight:"5px",marginTop:"5px",
          marginBottom:"5px",
          borderColor: '#E0E0E0',
              p: 2,
              borderRadius: 1}} onSubmit={handleSave}>
          <h5 style={{ color: '#000000', marginTop:"20px"}} className="text-center">Update complaints Record</h5>
          <Divider  sx={{       
              border: '1px solid',
              borderColor: colors.grey[200]
            
            }}/>   
                 
          <Box className="outerbox" sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 2fr)', gap: 1 ,m:1}}>
            <Item>
              <FormControl size="medium" fullWidth>
                <TextField
                  size="small"
                  label="Warranty Rejection Advice No"
                  name="warranty_rejection_advice_no"
                  disabled
                  value={editData.warranty_rejection_advice_no || ''}
                  onChange={handleChange}
                  fullWidth
                />
                <Bar/>
                <TextField
                  size="small"
                  disabled
                  label="Warranty Rejection Advice Date"
                  name="warranty_rejection_advice_date"
                  value={editData.warranty_rejection_advice_date.split('T')[0] || ''}
                  onChange={handleChange}
                  fullWidth
                 />
                <Bar/>
                <TextField
                  size="small"
                  label="Recovery Effective Date"
                  name="recovery_effective_date"
                  type="date"
                  value={editData.recovery_effective_date ? String(editData.recovery_effective_date).split('T')[0] : ''}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
                <Bar/>
                <TextField
                  size="small"
                  label="Warranty Complaint From"
                  name="warranty_complaint_from"
                  defaultValue={editData.warranty_complaint_from || ''}
                  onChange={handleChange}
                  fullWidth
                />
                <Bar/>
                <TextField
                  size="small"
                  label="RLY"
                  name="rly"
                  defaultValue={editData.rly || ''}
                  onChange={handleChange}
                  fullWidth
                />
                <Bar/>
                <TextField
                  size="small"
                  label="Item"
                  name="item"
                  defaultValue={editData.item || ''}
                  onChange={handleChange}
                  fullWidth
                />
                <Bar/>
              </FormControl>
            </Item>         
            <Item>
              <FormControl size="medium" fullWidth>
                <TextField
                size="small"
                label="Qty Rejected"
                name="qty_rejected_under_warranty"
                defaultValue={editData.qty_rejected_under_warranty || ''}
                onChange={handleChange}
                fullWidth
              />
              <Bar/>
              <TextField
              size="small"
              label="Inspection By"
              name="inspection_by"
              defaultValue={editData.inspection_by || ''}
              onChange={handleChange}
              fullWidth
              />
              <Bar/>
              {/* <TextField
                size="small"                
                label="Manufacturing Date"
                name="manufacturing_date"
                disabled
                value={monthyear || ''}
                onChange={handleChange}
                fullWidth
              /> */}
              <DatePicker
                  selected={editData.manufacturing_date ? new Date(editData.manufacturing_date) : null}
                  onChange={(date) => setEditData({ ...editData, manufacturing_date: date })}
                  dateFormat="yyyy-MM-dd"
                  className="dPick"
                />
{/*               
              <DatePicker
                    disabledKeyboardNavigation
                    showMonthYearPicker
                    required
                    disabled
                    name="manufacturing_date"
                    selected={monthyear}          
                    className="dPick"
                    popperProps={{
                      positionFixed: true // use this to make the popper position: fixed
                    }}                    
                      autoComplete="off"        
                      onChange={(monthyear) => setMonthYear(new Date(monthyear))}
                      dateFormat="MMM-yyyy"
                    /> */}
             <Bar/>         
            <TextField
              label="Life of Item"
              name="life_of_item"
              size="small"
              defaultValue={editData.life_of_item || ''}
              onChange={handleChange}
              fullWidth
            />
            <Bar/>
            <TextField
              size="small"
              label="Original Claim Value"
              name="original_claim_value"
              defaultValue={editData.original_claim_value || ''}
              onChange={handleChange}
              fullWidth
            />
            <Bar/>
            <TextField
              size="small"
              label="Reason Of Rejection"
              name="reason_of_rejection"
              value={editData.reason_of_rejection || ''}
              onChange={handleChange}
              fullWidth
            />
            </FormControl>
            </Item>
          </Box>
          <Box sx={{marginTop:'10px',marginBottom:'10px',  display: 'flex',  justifyContent: 'center', padding:'3px'}}>
              <Stack spacing={2} direction="row">
                <button margin="2" size="medium" className="btn btn-primary center">Update</button>
                {/* <button onClick={handleClose} className="btn btn-primary">Close</button> */}
              </Stack>
          </Box>



        </form>
    </div>
    </Modal>
  ) : "";
};

export default Edit;